import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { BottomFloatingButton } from '../../../../components/common/buttons/FloatingButtons/BottomFloatingButton';
import { Icon } from '../../../../components/common/icon/Icon';

export const CreateOwnTractorButton = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    ampli.pvmClickOwnTractorButton();
    ReactGA.event('pvm_click_enroll_own_tractor_button', {
      isModal: false,
    });
    navigate('/survey/entry/own-tractor');
  };

  return (
    <BottomFloatingButton
      handleButtonClick={handleButtonClick}
      icon={<Icon name={'Plus2'} width={20} height={20} />}
      title={'보유 트랙터 등록'}
    />
  );
};
